import { useTranslation } from 'react-i18next';
import { LegalPageLayout } from './LegalPageLayout';

function Section({ heading, body }: { heading: string; body: string }) {
  return (
    <section className="mb-8">
      <h2 className="text-[20px] font-semibold text-[#E2EDE7] mb-3">{heading}</h2>
      <p className="whitespace-pre-line text-[15px] leading-[1.7] text-[#788A82]">
        {body}
      </p>
    </section>
  );
}

export default function ImpressumPage() {
  const { t } = useTranslation('legal');

  return (
    <LegalPageLayout title={t('impressum.title')}>
      <Section
        heading={t('impressum.companyHeading')}
        body={`${t('impressum.companyName')}\n${t('impressum.address')}`}
      />
      <Section
        heading={t('impressum.contactHeading')}
        body={`${t('impressum.email')}\n${t('impressum.phone')}`}
      />
      <Section
        heading={t('impressum.registrationHeading')}
        body={`${t('impressum.registrationEntry')}\n${t('impressum.registrationCourt')}`}
      />
      <Section heading={t('impressum.vatIdHeading')} body={t('impressum.vatId')} />
      <Section
        heading={t('impressum.representativeHeading')}
        body={t('impressum.representative')}
      />
      <Section
        heading={t('impressum.contentResponsibilityHeading')}
        body={t('impressum.contentResponsibility')}
      />
      <Section
        heading={t('impressum.disputeResolutionHeading')}
        body={t('impressum.disputeResolution')}
      />
      <Section
        heading={t('impressum.disclaimerHeading')}
        body={t('impressum.disclaimer')}
      />
    </LegalPageLayout>
  );
}
